export const STEPS = [
    { key: 'profession', order: 0, required: true, label: 'onboarding.professionTitle' },
    { key: 'website', order: 1, required: true, label: 'onboarding.step1Title' },
    { key: 'header', order: 2, required: true, label: 'onboarding.step3Title' },
    { key: 'avatar', order: 3, required: false, label: 'onboarding.step2Title' },
    { key: 'services', order: 4, required: true, label: 'onboarding.step4Title' },
    { key: 'schedule', order: 5, required: true, label: 'onboarding.step5Title' },
    { key: 'gallery', order: 5.5, required: false, label: 'onboarding.step55Title' },
    { key: 'telephone', order: 6, required: false, label: 'onboarding.step6Title' },
    { key: 'email', order: 7, required: false, label: 'onboarding.step7Title' },
    { key: 'social', order: 8, required: false, label: 'onboarding.step8Title' },
    { key: 'impressum', order: 9, required: false, label: 'onboarding.step9Title' },
    { key: 'cookies', order: 10, required: true, label: null },
];

export const STEP_ROUTE_MAP = {
    profession: 'onboarding.profession',
    website: 'onboarding.website',
    avatar: 'onboarding.avatar',
    header: 'onboarding.header',
    services: 'onboarding.services',
    schedule: 'onboarding.schedule',
    gallery: 'onboarding.gallery',
    telephone: 'onboarding.telephone',
    email: 'onboarding.email',
    social: 'onboarding.social',
    impressum: 'onboarding.impressum',
};

export default {
    namespaced: true,
    state: () => ({
        websiteId: null,
        pageId: null,
        scheduleId: null,
        completedSteps: {},
    }),
    getters: {
        websiteId: (state) => state.websiteId,
        pageId: (state) => state.pageId,
        scheduleId: (state) => state.scheduleId,
        completedSteps: (state) => state.completedSteps,
        isStepComplete: (state) => (key) => !!state.completedSteps[key],
        allRequiredComplete: (state) => {
            return STEPS.filter(s => s.required).every(s => !!state.completedSteps[s.key]);
        },
        firstIncompleteStep: (state) => {
            for (const step of STEPS) {
                if (!state.completedSteps[step.key]) {
                    return step;
                }
            }
            return null;
        },
        firstIncompleteRequiredStep: (state) => {
            for (const step of STEPS) {
                if (step.required && !state.completedSteps[step.key]) {
                    return step;
                }
            }
            return null;
        },
        nextStep: (state) => (currentKey) => {
            const idx = STEPS.findIndex(s => s.key === currentKey);
            if (idx >= 0 && idx < STEPS.length - 1) {
                return STEPS[idx + 1];
            }
            return null;
        },
        completedCount: (state) => {
            return Object.values(state.completedSteps).filter(Boolean).length;
        },
        totalSteps: () => STEPS.length,
        visibleSteps: () => STEPS.filter(s => s.label !== null),
    },
    mutations: {
        SET_WEBSITE_ID(state, id) { state.websiteId = id; },
        SET_PAGE_ID(state, id) { state.pageId = id; },
        SET_SCHEDULE_ID(state, id) { state.scheduleId = id; },
        SET_STEP_COMPLETE(state, { key, value }) {
            state.completedSteps = { ...state.completedSteps, [key]: value };
        },
        SET_COMPLETED_STEPS(state, steps) { state.completedSteps = steps; },
        RESTORE(state, saved) {
            state.websiteId = saved.websiteId ?? null;
            state.pageId = saved.pageId ?? null;
            state.scheduleId = saved.scheduleId ?? null;
            state.completedSteps = saved.completedSteps ?? {};
        },
        RESET(state) {
            state.websiteId = null;
            state.pageId = null;
            state.scheduleId = null;
            state.completedSteps = {};
        },
    },
    actions: {
        completeStep({ commit }, key) {
            commit('SET_STEP_COMPLETE', { key, value: true });
        },
        setWebsite({ commit }, { websiteId, pageId }) {
            commit('SET_WEBSITE_ID', websiteId);
            commit('SET_PAGE_ID', pageId);
        },
        setSchedule({ commit }, scheduleId) {
            commit('SET_SCHEDULE_ID', scheduleId);
        },
        reset({ commit }) {
            commit('RESET');
        },
    },
};
